(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asap-black-friday-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asap-black-friday-banner')) {
    customElements.define('asap-black-friday-banner', class extends HTMLElement {
      connectedCallback() {
        this.endsAt = Number(this.dataset.endsAt);
        this.countdown = this.querySelector('[data-countdown-timer]');
        this.daysNode = this.querySelector('[data-timer-days]');
        this.clockNode = this.querySelector('[data-timer-clock]');
        this.refresh = () => {
          clearTimeout(this.expiryTimer);
          const remaining = this.endsAt - Date.now();
          this.hidden = !Number.isFinite(remaining) || remaining <= 0;
          if (!this.hidden && this.countdown) {
            const total = Math.ceil(remaining / 1000);
            const days = Math.floor(total / 86400);
            const hours = Math.floor(total % 86400 / 3600);
            const minutes = Math.floor(total % 3600 / 60);
            const seconds = total % 60;
            const pad = value => String(value).padStart(2, '0');
            this.daysNode.textContent = String(days);
            this.clockNode.textContent = [hours, minutes, seconds].map(pad).join(':');
            const accessible = this.countdown.dataset.accessible.replaceAll('__DAYS__', String(days)).replaceAll('__HOURS__', String(hours)).replaceAll('__MINUTES__', String(minutes)).replaceAll('__SECONDS__', String(seconds));
            this.countdown.setAttribute('aria-label', accessible);
          }
          this.syncHeader();
          if (!this.hidden && !document.hidden) this.expiryTimer = setTimeout(this.refresh, Math.min(remaining, 1000));
        };
        this.onVisibility = () => { if (!document.hidden) this.refresh(); };
        this.sizeObserver = new ResizeObserver(() => this.syncHeader());
        this.sizeObserver.observe(this);
        document.addEventListener('visibilitychange', this.onVisibility);
        window.addEventListener('pageshow', this.refresh);
        this.refresh();
      }
      syncHeader() {
        if (!this.hidden) {
          document.documentElement.setAttribute('data-asap-bf-visible', '');
          document.documentElement.style.setProperty('--asap-bf-height', this.getBoundingClientRect().height + 'px');
        } else {
          document.documentElement.removeAttribute('data-asap-bf-visible');
          document.documentElement.style.removeProperty('--asap-bf-height');
        }
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        this.sizeObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('pageshow', this.refresh);
        if (!document.querySelector('asap-black-friday-banner:not([hidden])')) {
          document.documentElement.removeAttribute('data-asap-bf-visible');
          document.documentElement.style.removeProperty('--asap-bf-height');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
